// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import FoundationHeader from './components/FoundationHeader';
import FoundationFooter from './components/FoundationFooter';

// Página de inicio combinada
import Home from './pages/Home';
import About from './pages/About';
import Mission from './pages/Mission';
import WhatWeDo from './pages/WhatWeDo';
import Contact from './pages/Contact';

const App = () => {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100 font-sans antialiased">
        <FoundationHeader />
        <main className="pt-20 md:pt-24">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nosotros" element={<About />} />
            <Route path="/mision-vision" element={<Mission />} />
            <Route path="/que-hacemos" element={<WhatWeDo />} />
            <Route path="/contacto" element={<Contact />} />
          </Routes>
        </main>
        <FoundationFooter />
      </div>
    </Router>
  );
};

export default App;
